import { combineReducers } from 'redux'
import { createReducer } from 'helpers/ReducerUtil'
import {
  UPDATE_PREVIEW_FILE,
  UPDATE_PREVIEW_LOADING,
  UPDATE_PREVIEW_SHOW
} from './constants'
import P from 'helpers/predicates'

const updatePreviewLoading = (prev, { loading }) => loading

const updatePreviewShow = (prev, { show }) => show

const updatePreviewFileLink = (prev, { link }) => P.isNotNil(link)
  ? link
  : prev

const updatePreviewFileName = (prev, { name }) => P.isNotNil(name)
  ? name
  : prev

const updatePreviewFileId = (prev, { id }) => P.isNotNil(id)
  ? id
  : prev

const loadingReducer = createReducer(false, {
  [UPDATE_PREVIEW_LOADING]: updatePreviewLoading
})

const showReducer = createReducer(false, {
  [UPDATE_PREVIEW_SHOW]: updatePreviewShow
})

const fileLinkReducer = createReducer(null, {
  [UPDATE_PREVIEW_FILE]: updatePreviewFileLink
})

const fileNameReducer = createReducer('', {
  [UPDATE_PREVIEW_FILE]: updatePreviewFileName
})

const fileIdReducer = createReducer(null, {
  [UPDATE_PREVIEW_FILE]: updatePreviewFileId
})

export default combineReducers({
  loading: loadingReducer,
  show: showReducer,
  fileLink: fileLinkReducer,
  fileName: fileNameReducer,
  fileId: fileIdReducer
})
